// Dates and Times
export const DATE_NO_YEAR_FORMAT = "DD/MM";
export const TIME_DISPLAY_FORMAT = "h:mm a";
export const DATE_DISPLAY_FORMAT = `${DATE_NO_YEAR_FORMAT}/YYYY`;
export const DATE_TIME_DISPLAY_FORMAT = `${TIME_DISPLAY_FORMAT}, ${DATE_DISPLAY_FORMAT}`;

// Messaging service
export const ALREADY_UPLOADED_TYPE = "already-uploaded";
